import React, { useState, useEffect } from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import ThemeToggle from '../ThemeToggle';
import i18n from '../i18n';

function LanguageThemeBar() {
    // Normalize language code (e.g., "en-US" -> "en", "de-DE" -> "ge")
    const normalizeLanguage = (langCode) => {
        if (!langCode) return 'en';
        const baseLang = langCode.split('-')[0].toLowerCase();
        if (baseLang === 'de' || baseLang === 'ge') return 'ge';
        if (baseLang === 'fr') return 'fr';
        return 'en'; // default to English
    };

    const [lang, setLang] = useState(normalizeLanguage(i18n.language));

    // Sync state with i18n language changes
    useEffect(() => {
        const handleLanguageChanged = (lng) => {
            setLang(normalizeLanguage(lng));
        };

        i18n.on('languageChanged', handleLanguageChanged);
        
        // Set initial language
        setLang(normalizeLanguage(i18n.language));

        return () => {
            i18n.off('languageChanged', handleLanguageChanged);
        };
    }, []);

    const handleLanguageChange = (event, newLang) => {
        setLang(newLang);
        i18n.changeLanguage(newLang);
    };

    return (
        <Box display="flex" alignItems="center">
            <Tabs
                value={lang}
                onChange={handleLanguageChange}
                textColor="inherit"
                indicatorColor="primary"
                sx={{ minHeight: '32px' }}
            >
                <Tab value="en" label="EN" sx={{ minHeight: '32px', minWidth: '48px' }} />
                <Tab value="ge" label="DE" sx={{ minHeight: '32px', minWidth: '48px' }} />
                <Tab value="fr" label="FR" sx={{ minHeight: '32px', minWidth: '48px' }} />
            </Tabs>

            <Box ml={4}>
                <ThemeToggle />
            </Box>
        </Box>
    );
}

export default LanguageThemeBar;
